import { useController } from 'react-hook-form';
import YesNoQuestion, {
    YesNoState,
} from '@alfa-retail-react/components/yes-no-question';
import React from 'react';
import { observer } from 'mobx-react';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { ProductParametersConfigureFormStore } from 'app/logic/pages/productParametersConfigure/ProductParametersConfigureFormStore';
import { ProductParametersConfigureFormValues } from 'app/logic/pages/productParametersConfigure/ProductParametersConfigurePage';

export interface InsuranceToggleFormItemProps {
    formStore: ProductParametersConfigureFormStore;
    title: string;
}

const INSURANCE_TOGGLE_FROM_ITEM_NAME = 'insuranceToggle';

export const InsuranceToggleFormItem = observer(
    (props: InsuranceToggleFormItemProps) => {

        const { formStore, title } = props;
        const { control, handleMultipleErrors, setFieldElement } =
            useFormContext<ProductParametersConfigureFormValues>();

        const { field, fieldState } =
            useController<ProductParametersConfigureFormValues>({
                name: INSURANCE_TOGGLE_FROM_ITEM_NAME,
                control,
                defaultValue: formStore.insuranceAppliedState,
                rules: {
                    validate: (value) => {
                        return formStore.insuranceRequired
                            ? YesNoState.YES === value ||
                                  'Обязательно заполните'
                            : true;
                    },
                },
            });

        return (
            <YesNoQuestion
                ref={(element) => {
                    field.ref(element);
                    setFieldElement(INSURANCE_TOGGLE_FROM_ITEM_NAME, element);
                }}
                question={title}
                className={'applyInsuranceCheckbox'}
                value={formStore.insuranceAppliedState}
                disabled={!formStore.hasAvailableInsurance}
                error={handleMultipleErrors(fieldState.error)}
                fields={[
                    { key: YesNoState.YES, title: 'Да' },
                    { key: YesNoState.NO, title: 'Нет' },
                ]}
                onChange={(event, value) => {
                    field.onChange(value);
                    formStore.setHasInsurance(value);
                }}
            />
        );
    },
);
